import {TranslateService} from '@ngx-translate/core';

import {LocalizationService} from '../../../../../shared/localization/localization.service';
import {Chart} from '../../key-metrics.interfaces';

import {Column} from './column';

export class Tornado extends Column {
  private dataAccus1: any;
  private dataAccus2: any;

  constructor(chart: Chart,
              translate: TranslateService,
              localization: LocalizationService) {
    super(chart, translate, localization);

    this.tooltip = {
      trigger: 'item',
      axisPointer: {
        type: 'shadow'
      },
      formatter: (item) => {
        return `${
          item.seriesName
        }: ${
          this.localization.localizeNumber(Math.abs(item.value), 'DECIMAL_2_DIGIT')
        }`;
      }
    };

    this.xAxis = [
      {
        type: 'value',
        axisLabel: {
          rotate: 45,
          formatter: (value) => this.localization.localizeNumber(Math.abs(value), 'DECIMAL_2_DIGIT')
        }
      }
    ];

    this.initDataAccus();

    if (this.chart.time) {
      this.createTimeChart();
    } else {
      this.createUnTimeChart();
    }
    this.generateTornadoTable(this.dataAccus1, this.dataAccus2);
  }

  public initDataAccus(): void {
    this.dataAccus1 = this.chart.time
      ? this.getAccusData(this.chart.accus1)
      : this.getAccusDataWithSort(this.chart.accus1);
    this.dataAccus2 = this.chart.time
      ? this.getAccusData(this.chart.accus2)
      : this.getAccusDataWithSort(this.chart.accus2);

    this.dataAccus1.forEach((element) => element.value *= -1);
  }

  public createTimeChart(): void {
    this.yAxis = [
      {
        type: 'category',
        axisTick: {show: false},
        data: this.categories
      }
    ];

    let resultAccus1: any[] = [];
    let resultAccus2: any[] = [];
    let resultAccus3: any[];
    this.categories.forEach((element) => {
      resultAccus1.push(this.dataAccus1.find((accusElement) => {

        return accusElement.name === element;
      }));
      resultAccus2.push(this.dataAccus2.find((accusElement) => {

        return accusElement.name === element;
      }));
    });

    resultAccus1 = this.monthSortData(resultAccus1);
    resultAccus2 = this.monthSortData(resultAccus2);
    resultAccus3 = resultAccus1.map((element, index) => {
      return {
        value: element.value + resultAccus2[index].value
      };
    });

    this.legend = {
      data: [
        this.translate.instant(resultAccus1[0].category),
        this.translate.instant(resultAccus2[0].category),
        this.translate.instant('Delta')
      ]
    };
    this.series = [
      this.getAccu(
        this.translate.instant(resultAccus1[0].category), 'left', resultAccus1.map(item => item.value)
      ),
      this.getAccu(
        this.translate.instant(resultAccus2[0].category), 'right', resultAccus2.map(item => item.value)
      ),
      {
        name: this.translate.instant('Delta'),
        type: 'bar',
        itemStyle: {
          normal: {
            barBorderRadius:5,
            barBorderWidth:1,
            label: {
              show: true,
              textStyle: {
                color: '#f8ad07'
              },
              position: 'right',
              formatter: (value) => value.value
                ? this.localization.localizeNumber(Math.abs(value.value), 'DECIMAL_2_DIGIT')
                : ''
            }
          }
        },
        data: resultAccus3.map(item => item.value)
      }
    ];
  }

  public createUnTimeChart(): void {
    const dataAccus3 = this.dataAccus1.map((element, index) => {
      if (!this.dataAccus2[index]) {
        return {
          value: 0
        };
      }

      return {
        value: element.value + this.dataAccus2[index].value
      };
    });
    this.tooltip = {
      trigger: 'item',
      axisPointer: {
        type: 'shadow'
      },
      formatter: (item) => {
        return `${
          item.seriesIndex === 0
            ? this.translate.instant(this.dataAccus1[item.dataIndex].category)
            : this.translate.instant(this.dataAccus2[item.dataIndex].category)
        }: ${
          this.localization.localizeNumber(Math.abs(item.value), 'DECIMAL_2_DIGIT')
        }`;
      }
    };
    this.yAxis = [
      {
        type: 'category',
        axisTick: {show: false},
        data: []
      }
    ];
    this.series = [
      this.getAccu('Accu1', 'left', this.dataAccus1.map(item => item.value)),
      this.getAccu('Accu2', 'right', this.dataAccus2.map(item => item.value)),
      {
        name: 'Delta',
        type: 'bar',
        itemStyle: {
          normal: {
            label: {
              show: true,
              position: 'inside',
              textStyle: {
                color: 'black'
              },
              formatter: (value) => this.localization.localizeNumber(Math.abs(value.value), 'DECIMAL_2_DIGIT')
            }
          }
        },
        data: dataAccus3.map(item => item.value),
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (item) => {
            return `${
              item.seriesName
            }: ${
              this.localization.localizeNumber(Math.abs(item.value), 'DECIMAL_2_DIGIT')
            }`;
          }
        }
      }
    ];
  }

  public getAccu(name: string, position: string, data: number[]): any {
    return {
      name: name,
      type: 'bar',
      stack: 'stack',
      itemStyle: {
        normal: {
          barBorderRadius:5,
          barBorderWidth:1,
          label: {
            show: true,
            position: position,
            formatter: (value) => value.value
              ? this.localization.localizeNumber(Math.abs(value.value), 'DECIMAL_2_DIGIT')
              : ''
          }
        }
      },
      data: data
    };
  }

  public resetChart(): void {
    this.resetDefault();
  }
}
